import { useAuthContext } from "@/hooks/useAuthContext";
import { useFirestore } from "@/hooks/useFirestore";
import { useUserContext } from "@/hooks/useUserContext";
import React from "react";

export default function CopyStep2() {
  return (
    <div>
      <div className="flex gap-2.5">
        <div className="shrink-0 border border-icon/50 w-8 h-8 rounded-full flex justify-center items-center text-lg font-semibold text-icon">
          2
        </div>
        <h1 className="font-semibold text-lg">
          Em seguida, clique no ícone com as 2 setas.
        </h1>
      </div>
      <div className="pl-[42px] flex flex-col gap-1.5">
        <p>Conforme print abaixo:</p>
      </div>
      <div className="mt-2.5 ml-[42px]">
        <img
          src="https://media.atomicatpages.net/u/0BVrOWOoOHYYehGtCMVYjXF1KZk1/Pictures/6f5kr/n2l5x/RJFSdt0942418.jpeg"
          className="w-72"
          alt=""
        />
      </div>
    </div>
  );
}
